<template>
  <div ref="productShippingCollapsibleElement">
    <Collapsible
      class="product-shipping-collapsible"
      :isCollapsed="isCollapsible"
      :maxHeight="145"
      :minHeightToCollapse="minHeightToCollapse"
      @toggle="onToggle"
    >
      <template #header>
        <div
          class="collapsible__header-wrapper"
          v-if="
            productStore.productShipping &&
            isCollapsible &&
            productShippingCollapsibleHeight > minHeightToCollapse
          "
        >
          <div class="collapsible__header-content">
            <span>
              {{
                isCollapsed ? 'View More on Shipping' : 'Less on Shipping'
              }}</span
            >
            <UpDownArrow :type="isCollapsed ? 'down' : 'up'" />
          </div>
        </div>
      </template>
      <template #body>
        <div
          :class="{
            'pb-md':
              productShippingCollapsibleHeight > minHeightToCollapse &&
              isCollapsible,
          }"
        >
          <slot></slot>
        </div>
      </template>
    </Collapsible>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, Ref, watch } from 'vue'
import Collapsible from '@/ui-kits/Collapsible.vue'
import UpDownArrow from '@/ui-kits/UpDownArrow.vue'
import useProductStore from '@/store/product'

withDefaults(defineProps<{ isCollapsible?: boolean }>(), {
  isCollapsible: false,
})

const productShippingCollapsibleElement: Ref<HTMLElement | null> = ref(null)
const productShippingCollapsibleHeight = ref(0)
const minHeightToCollapse = 70
const isCollapsed = ref(true)
const productStore = useProductStore()

onMounted(() => {
  if (!productShippingCollapsibleElement.value) return
  watch(
    () => productStore.productShipping,
    () => {
      productShippingCollapsibleHeight.value =
        productShippingCollapsibleElement.value?.offsetHeight
    },
    { immediate: true }
  )
})

function onToggle(isCollapsedInput: boolean) {
  isCollapsed.value = isCollapsedInput
}
</script>

<style lang="scss">
.product-shipping-collapsible {
  .collapsible {
    &__header {
      background: #ffffff;
      position: absolute;
      bottom: 0;
      width: 100%;
      z-index: var(--base-z-index);
      color: var(--color-primary);
      font-size: 12px;
    }
    &__header-wrapper {
      display: flex;
      align-items: flex-end;
      width: 100%;
      padding-bottom: 0.7em;
      padding-top: 0.5rem;
      z-index: 1;
    }
    &__header-content {
      display: flex;
      align-items: center;
      text-decoration: underline;
      gap: 0.5em;
    }
  }
}
</style>
